import { apiFetch } from "../../lib/api";
import type { ConnectorType } from "../stations/connectors";

export type ConnectorRequest = {
  connector_type: ConnectorType;
  power_kw: number;
};

export type SubmitStationRequestArgs = {
  name: string;
  address?: string;
  connectors: ConnectorRequest[];
  locale?: string;
  cfTurnstileResponse?: string;
};

export async function submitStationRequest(args: SubmitStationRequestArgs): Promise<void> {
  await apiFetch<void>("/station-requests", {
    method: "POST",
    body: {
      name: args.name,
      address: args.address ?? null,
      connectors: args.connectors,
      locale: args.locale ?? null,
      cf_turnstile_response: args.cfTurnstileResponse ?? null,
    },
  });
}
